(function(){
  var rcTimer;
  function initRC(){
    var wrap=document.querySelector('.cart-drawer .eut-rc[data-eut-rc]');
    if(!wrap||wrap.dataset.rcReady)return;
    wrap.dataset.rcReady='1';
    var slides=wrap.querySelectorAll('.eut-rc__slide'),dots=wrap.querySelectorAll('.eut-rc__dot');
    if(slides.length<2)return;
    clearInterval(rcTimer);var cur=0;
    rcTimer=setInterval(function(){
      var prev=cur;cur=(cur+1)%slides.length;
      slides[prev].classList.add('is-exit');slides[prev].classList.remove('is-active');
      slides[cur].classList.add('is-active');
      if(dots[prev])dots[prev].classList.remove('is-active');if(dots[cur])dots[cur].classList.add('is-active');
      setTimeout(function(){slides[prev].style.transition='none';slides[prev].classList.remove('is-exit');void slides[prev].offsetHeight;slides[prev].style.transition='';},580);
    },parseInt(wrap.dataset.speed,10)||3000);
  }
  function initWish(){
    var el=document.querySelector('.cart-drawer [data-eut-wishlist-count]');
    if(!el)return;
    var n=0;
    try{var d=JSON.parse(localStorage.getItem('eut_wishlist')||'[]');if(Array.isArray(d))n=d.length;else if(d&&Array.isArray(d.items))n=d.items.length;else if(d&&typeof d==='object')n=Object.keys(d).length;}catch(e){}
    if(el.textContent!==String(n))el.textContent=String(n);
  }
  function refreshDrawer(){document.dispatchEvent(new CustomEvent('cart:refresh'));}
  // ── (-) a 1 => retirer l'article ──
  // Le theme bride la quantite : app.js fait `quantity = Math.max(quantity, 1)`,
  // donc min="0" sur le champ est ignore et l'article n'est jamais supprime.
  // On intercepte en phase capture (avant le handler du theme, pose sur le bouton)
  // et on declenche le lien .remove que le theme cable deja sur chaque ligne.
  document.addEventListener('click',function(e){
    if(!e.target.closest)return;
    var minus=e.target.closest('.cart-drawer .eut-item .minus');
    if(!minus)return;
    var sel=minus.closest('quantity-selector');
    var input=sel&&sel.querySelector('.qty');
    if(!input||Number(input.value)>1)return;
    e.preventDefault();e.stopPropagation();
    var rm=minus.closest('.eut-item').querySelector('.remove');
    if(rm)rm.click();
  },true);
  // ── Ajouter (addon / upsell / coups de coeur) : AJAX au lieu de rediriger ──
  document.addEventListener('submit',function(e){
    var form=e.target;if(!form||!form.getAttribute)return;
    var act=form.getAttribute('action')||'';
    if(act.indexOf('/cart/add')<0||!form.closest('.cart-drawer'))return;
    e.preventDefault();
    var input=form.querySelector('[name="id"]');if(!input||!input.value)return;
    var id=String(input.value);
    var btn=form.querySelector('button[type="submit"]'),orig=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='…';}
    // Anti-doublon de ligne : si ce variant est deja au panier, on incremente
    // CETTE ligne (par sa key) au lieu d'ajouter une 2e ligne. Un meme variant
    // peut sinon creer une ligne distincte quand les proprietes de ligne different
    // selon le bouton d'ajout (fiche produit vs upsell) -> Shopify ne fusionne pas.
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();})
      .then(function(cart){
        var ex=(cart.items||[]).filter(function(it){return String(it.id)===id;})
          .sort(function(a,b){return b.quantity-a.quantity;})[0];
        if(ex)return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:ex.key,quantity:ex.quantity+1})});
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})});
      })
      .then(function(r){if(!r||!r.ok)throw 0;if(btn)btn.textContent='Ajouté ✓';refreshDrawer();})
      .catch(function(){if(btn){btn.disabled=false;btn.textContent=orig;}});
  });
  document.addEventListener('click',function(e){
    if(!e.target.closest)return;
    // ── Tout ajouter (liste d'envies) → ajoute vraiment au panier ──
    var wa=e.target.closest('[data-eut-wishlist-add]');
    if(wa){
      e.preventDefault();
      var wl={};try{wl=JSON.parse(localStorage.getItem('eut_wishlist')||'{}');}catch(err){}
      var items=Array.isArray(wl)?wl:Object.keys(wl).map(function(k){return wl[k];});
      items=items.filter(function(i){return i&&i.handle;});
      if(!items.length)return;
      var orig=wa.textContent;wa.textContent='…';wa.style.pointerEvents='none';
      Promise.all(items.map(function(i){return fetch('/products/'+i.handle+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});}))
        .then(function(ps){
          var payload=ps.filter(Boolean).map(function(p){return{id:p.variants[0].id,quantity:1};});
          if(!payload.length){wa.textContent=orig;wa.style.pointerEvents='';return;}
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:payload})})
            .then(function(){refreshDrawer();})
            .catch(function(){wa.textContent=orig;wa.style.pointerEvents='';});
        });
      return;
    }
    var arw=e.target.closest('.eut-up__arrow');
    if(arw){var up=arw.closest('.eut-up');var rail=up&&up.querySelector('.eut-up__rail');if(rail)rail.scrollBy({left:(parseInt(arw.dataset.dir,10)||1)*230,behavior:'smooth'});}
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter'||!e.target.closest)return;
    var pi=e.target.closest('[data-eut-promo]');if(!pi)return;
    e.preventDefault();var code=pi.value.trim();if(!code)return;
    window.location.href='/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(window.location.pathname);
  });
  var host=document.getElementById('Cart-Drawer')||document.body;
  new MutationObserver(function(){initRC();initWish();}).observe(host,{childList:true,subtree:true});
  if(document.readyState!=='loading'){initRC();initWish();}else{document.addEventListener('DOMContentLoaded',function(){initRC();initWish();});}
})();
